(() => {
  const flagUrl = document.currentScript?.dataset.moroccoFlag;
  const destination = document.querySelector(".qeydo-cod-form");
  const product = destination?.closest(".product__info-container");
  if (!product) return;


  const addButton = product.querySelector(".product-form__submit");
  const cartIcon = addButton?.querySelector(".icon-cart");

  const syncButtonStyle = () => {
    if (!addButton) return;
    const style = getComputedStyle(addButton);
    const properties = {
      "background": "backgroundColor",
      "text": "color",
      "size": "fontSize",
      "weight": "fontWeight",
      "radius": "borderRadius",
      "height": "height",
    };
    for (const [name, key] of Object.entries(properties)) {
      destination.style.setProperty(`--qeydo-cod-button-${name}`, style[key]);
    }
  };

  const decorateButton = () => {
    const button = destination.querySelector(".rsi-submit_button");
    if (!button || button.querySelector(".qeydo-cod-button-label")) return;
    const label = document.createElement("span");
    label.className = "qeydo-cod-button-label";
    label.textContent = "Valider la commande";
    if (cartIcon) {
      const icon = cartIcon.cloneNode(true);
      icon.setAttribute("aria-hidden", "true");
      label.append(icon);
    }
    button.append(label);
  };

  const wideLayout = matchMedia("(min-width: 750px)");
  const buttonPositions = new WeakMap();
  const galleryLayout = product.closest(".product__outer");
  const gallery = galleryLayout?.querySelector(":scope > .product__main");
  if (gallery?.querySelector("[data-qeydo-gallery]")) {
    galleryLayout.classList.add("qeydo-sticky-gallery-layout");
    let frame = 0;
    const updateGallery = () => {
      frame = 0;
      if (!wideLayout.matches) {
        gallery.style.removeProperty("--qeydo-gallery-offset");
        return;
      }
      const bounds = gallery.getBoundingClientRect();
      const offset = parseFloat(gallery.style.getPropertyValue("--qeydo-gallery-offset")) || 0;
      const start = bounds.top - offset;
      const form = destination.getBoundingClientRect();
      const end = form.height ? form.top : product.getBoundingClientRect().bottom;
      const header = document.querySelector(".shopify-section-header-sticky:not(.shopify-section-header-hidden)");
      const top = Math.max(0, header?.getBoundingClientRect().bottom || 0) + 16;
      const travel = Math.max(0, Math.min(top - start, end - start - bounds.height - 16));
      gallery.style.setProperty("--qeydo-gallery-offset", travel + "px");
    };
    const scheduleGallery = () => {
      if (frame) return;
      frame = requestAnimationFrame(updateGallery);
    };
    window.addEventListener("scroll", scheduleGallery, { passive: true });
    window.addEventListener("resize", scheduleGallery);
    const galleryObserver = new ResizeObserver(scheduleGallery);
    galleryObserver.observe(product);
    galleryObserver.observe(gallery);
    galleryObserver.observe(destination);
  }

  const placeForm = () => {
    const embeddedForm = product.querySelector("#_rsi-form-container-embedded");
    if (embeddedForm && embeddedForm.parentElement !== destination) {
      destination.append(embeddedForm);
    }
    decorateButton();

    const summary = destination.querySelector(".rsi-total-summary-wrapper");
    const firstField = destination.querySelector(".rsi-text-input-row");
    if (summary && firstField) {
      let summaryColumn = summary;
      while (summaryColumn.parentElement !== destination &&
          !summaryColumn.parentElement.contains(firstField)) {
        summaryColumn = summaryColumn.parentElement;
      }
      const columns = summaryColumn.parentElement;
      const fieldsColumn = [...columns.children].find(child => child.contains(firstField));
      if (columns !== destination && fieldsColumn !== summaryColumn &&
          summaryColumn.querySelector(".rsi-shipping-rates-item") &&
          fieldsColumn?.querySelectorAll(".rsi-text-input-row").length > 1) {
        columns.classList.add("qeydo-cod-desktop-columns");
        summaryColumn.classList.add("qeydo-cod-desktop-summary");
        fieldsColumn.classList.add("qeydo-cod-desktop-fields");
        const button = columns.querySelector(".rsi-submit_button");
        if (button && button.closest("form") === fieldsColumn.closest("form") &&
            button.closest(".rsi-form-main") === fieldsColumn.closest(".rsi-form-main")) {
          if (wideLayout.matches && !fieldsColumn.contains(button)) {
            const position = document.createComment("Original Releasit submit position");
            button.before(position);
            buttonPositions.set(button, position);
            fieldsColumn.append(button);
          } else if (!wideLayout.matches) {
            const position = buttonPositions.get(button);
            if (position?.isConnected) {
              position.replaceWith(button);
              buttonPositions.delete(button);
            }
          }
        }
      }
    }
    for (const image of destination.querySelectorAll('#_rsi-form-container-embedded img')) {
      const thumbnail = image.closest("picture") || image;
      for (const sibling of thumbnail.parentElement.children) {
        if (/^\d+$/.test(sibling.textContent.trim()) && getComputedStyle(sibling).position === "absolute") {
          sibling.classList.add("qeydo-cod-quantity-badge");
        }
      }
    }

    const installation = [...destination.querySelectorAll(".rsi-shipping-rates-item")]
      .find(item => item.getClientRects().length && /installation offerte/i.test(item.textContent));
    let previous;
    for (const row of destination.querySelectorAll(".rsi-text-input-row")) {
      let wrapper = row.parentElement;
      while (
        wrapper && wrapper !== destination &&
        wrapper.querySelectorAll(".rsi-text-input-row").length === 1 &&
        !wrapper.querySelector(".rsi-submit_button, .rsi-shipping-rates-wrapper, .rsi-total-summary-wrapper")
      ) {
        wrapper.classList.add("qeydo-cod-field-shell");
        for (const property of ["margin-block", "padding-block", "min-height", "row-gap"]) {
          wrapper.style.setProperty(property, "0", "important");
        }
        wrapper = wrapper.parentElement;
      }
      if (wrapper && wrapper !== destination) {
        wrapper.style.setProperty("row-gap", "0", "important");
      }
      const fieldKey = row.querySelector("input, textarea");
      const spacingKey = fieldKey && [fieldKey.name, fieldKey.id, fieldKey.placeholder].join(" ");
      if (spacingKey && (fieldKey.type === "tel" || /name|nom|phone|city|ville|address|adresse/i.test(spacingKey)) && row.getClientRects().length) {
        const followsInstallation = !previous && installation && /name|nom/i.test(spacingKey) &&
          Boolean(installation.compareDocumentPosition(row) & Node.DOCUMENT_POSITION_FOLLOWING);
        const preceding = previous || (followsInstallation ? installation : null);
        if (preceding) {
          const shell = wrapper?.querySelector(":scope > .qeydo-cod-field-shell:has(.rsi-text-input-row)") && row.closest(".qeydo-cod-field-shell") ? (() => { let shell = row.closest(".qeydo-cod-field-shell"); while (shell.parentElement.classList.contains("qeydo-cod-field-shell")) shell = shell.parentElement; return shell; })() : row;
          const error = preceding.closest(".rsi-text-input-wrapper")?.querySelector(".rsi-text-input-error-row");
          const bottom = preceding.getBoundingClientRect().bottom;
          const errorBottom = error?.textContent.trim() ? error.getBoundingClientRect().bottom : bottom;
          const gap = row.getBoundingClientRect().top - Math.max(bottom, errorBottom);
          const targetGap = followsInstallation ? 12 : 8;
          const currentMargin = parseFloat(getComputedStyle(shell).marginBlockStart) || 0;
          shell.style.setProperty("margin-block-start", (currentMargin + targetGap - gap) + "px", "important");
        }
        previous = row;
      } else {
        previous = undefined;
      }
      row.parentElement.classList.add("qeydo-cod-field-inner");
      const holder = row.querySelector(".rsi-text-input-icon");
      const field = row.querySelector("input, textarea");
      if (!holder || !field || holder.querySelector(".qeydo-cod-field-icon, .qeydo-cod-phone-prefix")) continue;
      const key = [field.name, field.id, field.placeholder].join(" ").toLowerCase();
      let glyph;
      if (field.type === "tel" || /phone|téléphone/.test(key)) glyph = "qeydo-phone-call";
      else if (/address|adresse/.test(key)) glyph = "qeydo-door";
      else if (/city|ville/.test(key)) glyph = "qeydo-location";
      else if (/name|nom/.test(key)) glyph = "user-1";
      if (!glyph) continue;
      if (glyph === "qeydo-phone-call" && flagUrl) {
        const prefix = document.createElement("span");
        prefix.className = "qeydo-cod-phone-prefix";
        prefix.setAttribute("aria-hidden", "true");
        const flag = document.createElement("img");
        flag.src = flagUrl;
        flag.alt = "";
        flag.width = 28;
        flag.height = 20;
        const dialCode = document.createElement("span");
        dialCode.textContent = "+212";
        if (/iPhone/.test(navigator.userAgent)) {
          dialCode.style.transform = "translateY(1px)";
        }
        prefix.append(flag, dialCode);
        holder.append(prefix);
        continue;
      }

      const icon = document.createElement("i");
      icon.className = `qeydo-cod-field-icon icon icon-pack icon-${glyph}`;
      icon.setAttribute("aria-hidden", "true");
      if (glyph === "qeydo-door") {
        const ns = "http://www.w3.org/2000/svg";
        const house = document.createElementNS(ns, "svg");
        house.setAttribute("class", "qeydo-cod-field-icon");
        house.setAttribute("viewBox", "0 0 24 24");
        house.setAttribute("aria-hidden", "true");
        const path = document.createElementNS(ns, "path");
        path.setAttribute("d", "M3 11l9-8 9 8M5 10v10h14V10M10 20v-6h4v6");
        path.setAttribute("fill", "none");
        path.setAttribute("stroke", "currentColor");
        path.setAttribute("stroke-width", "1.6");
        path.setAttribute("stroke-linecap", "round");
        path.setAttribute("stroke-linejoin", "round");
        house.append(path);
        holder.append(house);
      } else {
        holder.append(icon);
      }
    }

  };

  wideLayout.addEventListener("change", placeForm);
  const observer = new MutationObserver(placeForm);
  observer.observe(product, { childList: true, subtree: true });
  new MutationObserver(syncButtonStyle).observe(document.documentElement, {
    attributes: true, attributeFilter: ["data-scheme"],
  });
  if (addButton) new ResizeObserver(syncButtonStyle).observe(addButton);
  syncButtonStyle();
  placeForm();
})();
